/**
 * HOA lookup → the seller listing's Edit terms inputs (Loop 1386).
 *
 * Two ways in, one fill (`fillHoaFields`):
 *  - Confirm: `acqs.views.listings.listing_hoa_confirm` answers with HX-Trigger
 *    `hoaLookupConfirmed` = {has_hoa: 'yes'|'no', hoa_id, hoa_name, hoa_dues}. htmx
 *    fires it on the Confirm button before the box swaps, so the event bubbles
 *    from inside the terms form, and only that form is filled.
 *  - "Use on this listing" (`[data-hoa-lookup-use]`): an already-confirmed result
 *    whose values this listing does not have yet. The button carries the same
 *    fill as data attributes; no request is sent, nothing is written. The button
 *    then gives way to the "Applied <date>" line rendered hidden beside it.
 * Nothing is saved here; the sheet's Save writes the listing.
 *
 * Order matters. The has_hoa radio goes first with a bubbling `change`, which
 * runs `syncHoa` (`offer-listing-form-conditions.js`): leaving Yes clears the
 * picker and dues, and Yes shows them. Then the picker is set through the same
 * path an inline create uses (`selectTypeaheadOption`), then the dues. With no dues found
 * (''), dues already typed stay when the picker already held this HOA, since they were typed
 * for it; a fill that changes the HOA blanks them.
 */
import { selectTypeaheadOption } from './combobox-inline-create.js';

function fillHoaFields(form, d) {
    if (!form || (d.has_hoa !== 'yes' && d.has_hoa !== 'no')) return false;

    var radio = form.querySelector('[data-listing-has-hoa][value="' + d.has_hoa + '"]');
    if (!radio) return false;
    // Read before the radio's `change`, which clears the picker when it leaves Yes.
    var hoaInput = form.querySelector('input[name="hoa"]');
    var sameHoa = d.has_hoa === 'yes' && hoaInput && hoaInput.value !== '' && hoaInput.value === String(d.hoa_id);
    radio.checked = true;
    radio.dispatchEvent(new Event('change', {bubbles: true}));

    if (d.has_hoa === 'yes' && d.hoa_id != null) {
        var host = form.querySelector('.typeahead[data-typeahead-target="hoa"]');
        if (host) selectTypeaheadOption(host, d.hoa_id, d.hoa_name || '');
    }

    var dues = form.querySelector('input[name="hoa_dues"]');
    if (dues && (d.hoa_dues || !sameHoa)) dues.value = d.hoa_dues || '';
    return true;
}

document.body.addEventListener('hoaLookupConfirmed', function (e) {
    fillHoaFields(e.target.closest && e.target.closest('form'), e.detail || {});
});

document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hoa-lookup-use]');
    if (!btn) return;
    var filled = fillHoaFields(btn.closest('form'), {
        has_hoa: btn.dataset.hasHoa,
        hoa_id: btn.dataset.hoaId || null,
        hoa_name: btn.dataset.hoaName,
        hoa_dues: btn.dataset.hoaDues,
    });
    if (!filled) return;
    // The same quiet line Confirm leaves; the server renders it hidden beside the button.
    var used = btn.parentNode.querySelector('[data-hoa-lookup-used]');
    if (used) {
        btn.hidden = true;
        used.hidden = false;
    }
    if (window.SeeMe && SeeMe.toast) SeeMe.toast.success('Filled from the saved HOA lookup');
});
